export const countryCityConstants = {
 
    ADD_CITY_REQUEST: 'ADD_CITY_REQUEST',
    ADD_CITY_SUCCESS: 'ADD_CITY_SUCCESS',
    ADD_CITY_FAILURE: 'ADD_CITY_FAILURE',
    FETCH_STATE_REQUEST: 'FETCH_STATE_REQUEST',
    FETCH_STATE_SUCCESS: 'FETCH_STATE_SUCCESS',
    FETCH_STATE_FAILURE: 'FETCH_STATE_FAILURE',
    FETCH_STATELOC_REQUEST: 'FETCH_STATELOC_REQUEST',
    FETCH_STATELOC_SUCCESS: 'FETCH_STATELOC_SUCCESS',
    FETCH_STATELOC_FAILURE: 'FETCH_STATELOC_FAILURE',
    FETCH_CITIES_REQUEST: 'FETCH_CITIES_REQUEST',
    FETCH_CITIES_SUCCESS: 'FETCH_CITIES_SUCCESS',
    FETCH_CITIES_FAILURE: 'FETCH_CITIES_FAILURE',
    DELETE_CITY_REQUEST: 'FETCH_DELETE_CITY_REQUEST',
    DELETE_CITY_SUCCESS: 'FETCH_DELETE_CITY_SUCCESS',
    DELETE_CITY_FAILURE: 'FETCH_DELETE_CITY_FAILURE',
    GET_CITY_DETAILS_REQUEST: 'GET_CITY_DETAILS_REQUEST',
    GET_CITY_DETAILS_SUCCESS: 'GET_CITY_DETAILS_SUCCESS',
    GET_CITY_DETAILS_FAILURE:'GET_CITY_DETAILS_FAILURE',
    GET_CITY_DETAILS_BYSTATE_REQUEST: 'GET_CITY_DETAILS_BYSTATE_REQUEST',
    GET_CITY_DETAILS_BYSTATE_SUCCESS: 'GET_CITY_DETAILS_BYSTATE_SUCCESS',
    GET_CITY_DETAILS_BYSTATE_FAILURE:'GET_CITY_DETAILS_BYSTATE_FAILURE',
    FETCH_COUNTRIES_REQUEST:'FETCH_COUNTRIES_REQUEST',
    FETCH_COUNTRIES_SUCCESS : 'FETCH_COUNTRIES_SUCCESS',
    FETCH_COUNTRIES_FAILURE : 'FETCH_COUNTRIES_FAILURE', 
    ADD_CITY_STATUS_REQUEST: 'ADD_CITY_STATUS_REQUEST',
    ADD_CITY_STATUS_SUCCESS: 'ADD_CITY_STATUS_SUCCESS',
    ADD_CITY_STATUS_FAILURE: 'ADD_CITY_STATUS_FAILURE',
    ADD_CITY_SOLDOUT_REQUEST: 'ADD_CITY_SOLDOUT_REQUEST',
    ADD_CITY_SOLDOUT_SUCCESS: 'ADD_CITY_SOLDOUT_SUCCESS',
    ADD_CITY_SOLDOUT_FAILURE: 'ADD_CITY_SOLDOUT_FAILURE',    
    GET_CITIES_REQUEST: 'GET_CITIES_REQUEST',
    GET_CITIES_SUCCESS: 'GET_CITIES_SUCCESS',
    GET_CITIES_FAILURE: 'GET_CITIES_FAILURE',
    GET_COUNTRIESCITY_REQUEST: 'GET_COUNTRIESCITY_REQUEST',
    GET_COUNTRIESCITY_SUCCESS: 'GET_COUNTRIESCITY_SUCCESS',
    GET_COUNTRIESCITY_FAILURE: 'GET_COUNTRIESCITY_FAILURE',
    ADD_FB_LINK_REQUEST: 'ADD_FB_LINK_REQUEST',
    ADD_FB_LINK_SUCCESS: 'ADD_FB_LINK_SUCCESS',
    ADD_FB_LINK_FAILURE: 'ADD_FB_LINK_FAILURE',
};


// WEBPACK FOOTER //
// ./src/app/redux/constants/countryCityConstants.js